/**
 * 스크롤 활동 감지 — 자동번역 viewport 게이트용.
 *
 * document 캡처 단계 scroll 리스너 1개로 (내부 스크롤 컨테이너 포함) 모든 스크롤을 감지하고,
 * 마지막 스크롤 후 SETTLE_MS 동안 추가 스크롤이 없으면 "멈춤"으로 판정한다.
 * MessageItem 들은 ScrollEmitter('change', boolean) 를 구독해, 스크롤 중엔 번역을 보류한다.
 *
 * scroll 이벤트는 버블링하지 않으므로 capture:true 로 document 에서 가로채 내부 컨테이너 스크롤도 감지.
 */
import { EventEmitter } from 'events';

export const ScrollEmitter = new EventEmitter();
ScrollEmitter.setMaxListeners(0);

// 마지막 스크롤 후 이 시간(ms) 동안 스크롤이 없으면 "멈춤"으로 판정 (스크롤이 완전히 끝난 뒤 번역 시작)
const SETTLE_MS = 500;

let scrolling = false;
let timer: ReturnType<typeof setTimeout> | undefined;
let started = false;

export function ensureScrollWatch(): void {
  if (started || typeof document === 'undefined') return;
  started = true;
  document.addEventListener(
    'scroll',
    () => {
      if (!scrolling) {
        scrolling = true;
        ScrollEmitter.emit('change', true);
      }
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        scrolling = false;
        ScrollEmitter.emit('change', false);
      }, SETTLE_MS);
    },
    { capture: true, passive: true },
  );
}

export function getScrolling(): boolean {
  return scrolling;
}
